import React from 'react';

function Mongolia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124056)">
        <mask
          id="mask0_800_124056"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124056)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.25 0H24.75V24H11.25V0Z"
            fill="#4C67E8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.75 0H36V24H24.75V0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H13.5V24H0V0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.76567 6.88421C5.62566 6.88421 5.7753 5.89687 5.7753 5.89687L6.31581 4.85927V5.27724V5.89687C6.31581 6.03033 6.52068 5.76341 6.52068 5.4421C6.52068 5.12079 6.76567 4.63965 6.76567 4.63965C6.76567 4.63965 6.77551 4.47877 6.78228 4.31991C6.8215 4.40164 6.9001 4.47241 7.01943 4.57985C7.04024 4.59859 7.06229 4.61844 7.08558 4.63965C7.22643 4.76795 7.20743 5.1078 7.19099 5.40184C7.1761 5.66814 7.16332 5.89687 7.27326 5.89687C7.5046 5.89687 7.4874 4.9781 7.4874 4.9781L7.87567 5.89687C7.87567 5.89687 7.90568 6.88421 6.76567 6.88421ZM6.76567 4.06453C6.79468 3.91378 6.79102 4.11516 6.78228 4.31991C6.74954 4.25167 6.74426 4.17578 6.76567 4.06453ZM8.48076 8.68377C8.48076 9.48647 7.72524 10.1372 6.79326 10.1372C5.86128 10.1372 5.10576 9.48647 5.10576 8.68377C5.10576 7.88108 5.86128 7.23037 6.79326 7.23037C7.72524 7.23037 8.48076 7.88108 8.48076 8.68377ZM4.24038 11.4043H2.25V19.9756H4.24038V11.4043ZM11.2499 11.4043H9.25955V19.9756H11.2499V11.4043ZM4.75955 11.4788L6.69987 12.5466L8.88673 11.4788H4.75955ZM6.69987 20L4.75955 18.9321H8.88673L6.69987 20ZM4.75955 12.8949H8.82686V13.5657H4.75955V12.8949ZM8.82686 17.8887H4.75955V18.5595H8.82686V17.8887ZM6.83647 17.516C7.98353 17.516 8.9134 16.7151 8.9134 15.7272C8.9134 14.7393 7.98353 13.9384 6.83647 13.9384C5.68942 13.9384 4.75955 14.7393 4.75955 15.7272C4.75955 16.7151 5.68942 17.516 6.83647 17.516ZM4.50357 9.21618C4.50357 9.21618 4.57349 11.0835 6.64407 11.0835C8.71464 11.0835 9.04883 9.21618 9.04883 9.21618C9.04883 9.21618 8.24738 10.36 6.7762 10.36C5.30502 10.36 4.50357 9.21618 4.50357 9.21618Z"
            fill="#F8D000"
          />
          <path
            d="M7.15336 13.9724L7.24615 13.6048C7.71019 14.0561 7.92039 14.3093 7.82108 14.7228C7.71022 15.1844 7.12736 15.6984 6.45019 16.1219C6.04005 16.3784 5.78879 17.0708 5.99233 17.291L5.79824 17.6048C5.34463 17.1142 5.70718 16.1884 6.33314 15.7969C6.90794 15.4374 7.30936 15.0604 7.37937 14.7637C7.42496 14.5705 7.50995 14.3192 7.15336 13.9724Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.3125 17C7.62316 17 7.875 16.7761 7.875 16.5C7.875 16.2239 7.62316 16 7.3125 16C7.00184 16 6.75 16.2239 6.75 16.5C6.75 16.7761 7.00184 17 7.3125 17Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.04785 15.6506C6.35851 15.6506 6.61035 15.4268 6.61035 15.1506C6.61035 14.8745 6.35851 14.6506 6.04785 14.6506C5.73719 14.6506 5.48535 14.8745 5.48535 15.1506C5.48535 15.4268 5.73719 15.6506 6.04785 15.6506Z"
            fill="#C51918"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124056">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Mongolia;
